export default __webpack_public_path__ + "static/img/35.49ef9b8.png";